import type { Filters } from '@ipfabric/utils';
import type {
  ApiTableCommandFactory,
  FiltersOrigin,
} from 'components/ApiTable/model/ApiTableModel';

interface SetFiltersCommand {
  filters: Filters;
  origin: FiltersOrigin;
}

export const setFilters: ApiTableCommandFactory<SetFiltersCommand> =
  (cmdContext) => (command) => {
    cmdContext.updateState((draft) => {
      draft.filters = command.filters;
      draft.filtersOrigin = command.origin;
    });
  };
